// eslint-disable-next-line jira/import-whitelist
import { WEB_RESOURCE_MAP } from '@atlassian/jira-dashboard-common/src/constants.tsx';
import type { GadgetData, WebResourceName } from '@atlassian/jira-dashboard-common/src/types.tsx';
// isReactKey is just a type guard, nothing controversial
// eslint-disable-next-line jira/import-whitelist
import {
	type ReactKey,
	type ReactGadgetIdentity,
	isReactKey,
} from '@atlassian/jira-react-gadgets-definition/src/main.tsx';

export const gadgetsToUniqueSortedAmdModules = (gadgets: GadgetData[]): WebResourceName[] =>
	gadgets // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		.map(({ amdModule }) => amdModule as WebResourceName) // validated below
		.filter(Boolean)
		.filter((amdModule) => amdModule in WEB_RESOURCE_MAP)
		.filter((v, i, a) => a.indexOf(v) === i)
		.sort() ?? [];

export const gadgetsToSortedReactGadgets = (gadgets: GadgetData[]): ReactGadgetIdentity[] =>
	gadgets
		.reduce<Array<ReactGadgetIdentity>>((gadgetsAccumulator, gadget) => {
			if (!isReactKey(gadget.reactKey)) return gadgetsAccumulator;
			gadgetsAccumulator.push({
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				reactKey: gadget.reactKey as ReactKey,
				id: gadget.id,
				userPrefs: gadget.userPrefs,
			});
			return gadgetsAccumulator;
		}, [])
		.sort((a, b) => a.id.localeCompare(b.id));
